import { Pagination as MuiPagination, PaginationItem as MuiPaginationItem } from '@mui/material';
import type { PaginationProps as MuiPaginationProps } from '@mui/material';
import { styled } from '@mui/material/styles';

import FontAwesomeIcon from '@components/atoms/fontAwesomeIcon';

export type PaginationProps = MuiPaginationProps;

export const StyledMuiPagination = styled(MuiPagination)(() => ({}));

export const StyledMuiPaginationItem = styled(MuiPaginationItem)(() => ({
  '&.MuiButtonBase-root.MuiPaginationItem-root.Mui-selected': {
    backgroundColor: '#00532A14',
    color: '#00532A',
  },
}));

/**
 * TODO
 * [ ] unit testing
 */
const Pagination = (props: PaginationProps) => (
  <StyledMuiPagination
    {...props}
    renderItem={(item) => (
      <StyledMuiPaginationItem
        components={{
          previous: () => <FontAwesomeIcon icon="fa-light fa-angle-left" style={{ margin: 0, color: '#00532A' }} />,
          next: () => <FontAwesomeIcon icon="fa-light fa-angle-right" style={{ margin: 0, color: '#00532A' }} />,
          first: () => <FontAwesomeIcon icon="fa-light fa-backward-step" style={{ margin: 0, color: '#00532A' }} />,
          last: () => <FontAwesomeIcon icon="fa-light fa-forward-step" style={{ margin: 0, color: '#00532A' }} />,
        }}
        {...item}
      />
    )}
  />
);

export default Pagination;
